import { NavLink, Outlet, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, LayoutDashboard, FileText, Users, Award, BadgeCheck, MessageSquare, HelpCircle, BookOpen, Layers, Inbox, Settings } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/casos", label: "Casos de éxito", icon: FileText },
  { to: "/admin/services", label: "Servicios", icon: Layers },
  { to: "/admin/normas", label: "Normas", icon: Award },
  { to: "/admin/clients", label: "Clientes", icon: Users },
  { to: "/admin/testimonials", label: "Testimonios", icon: MessageSquare },
  { to: "/admin/faqs", label: "Preguntas frecuentes", icon: HelpCircle },
  { to: "/admin/resources", label: "Recursos", icon: BookOpen },
  { to: "/admin/sectors", label: "Sectores", icon: BadgeCheck },
  { to: "/admin/contact_requests", label: "Solicitudes", icon: Inbox },
  { to: "/admin/site", label: "Info del sitio", icon: Settings },
];

export default function AdminLayout() {
  const { user, checking, logout } = useAuth();
  if (checking) return <div className="min-h-screen flex items-center justify-center bg-[#F9F6F0]">Cargando...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-[#F9F6F0] text-[#1A1A1A] flex" data-testid="admin-layout">
      <aside className="w-[260px] shrink-0 border-r border-[#1A1A1A]/10 flex flex-col" data-testid="admin-sidebar">
        <div className="p-6 border-b border-[#1A1A1A]/10 flex items-center gap-3">
          <img src="/kb-logo.png" alt="KB" className="h-10 w-auto" />
          <div>
            <div className="text-xs eyebrow">Panel</div>
            <div className="text-sm">KB Consultoría</div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 text-sm rounded ${isActive ? "bg-[#1B3B2B] text-[#F9F6F0]" : "hover:bg-[#EFEBE2]"}`
              }
              data-testid={`admin-nav-${to.split("/").pop() || "dashboard"}`}
            >
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-[#1A1A1A]/10 space-y-2">
          <Link to="/" className="flex items-center gap-2 text-xs text-[#4A4A4A] hover:text-[#1A1A1A] px-3 py-2" data-testid="admin-back-site">
            ← Ir al sitio
          </Link>
          <button onClick={logout} className="w-full flex items-center gap-2 text-xs px-3 py-2 rounded hover:bg-[#EFEBE2]" data-testid="admin-logout">
            <LogOut className="w-4 h-4" /> Cerrar sesión
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden" data-testid="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
